// src/components/IncomingOrders/helpers/buildAddressCompareRows.js

import { hasStringValue } from "./addressUtils";

const buildAddressCompareRows = (
  normalizedColumns,
  editable,
  fieldOrder
) => {
  const visibleKeys = fieldOrder.filter((key) =>
    normalizedColumns.some((c) => hasStringValue(c.address?.[key]))
  );

  const keysToRender =
    visibleKeys.length > 0
      ? visibleKeys
      : editable
        ? fieldOrder
        : [];

  return keysToRender.flatMap((key) => {
    const titleColumnMap = new Map();

    normalizedColumns.forEach((col, colIdx) => {
      const rawTitle = col.getAddressLabel?.(key) ?? key;
      const trimmed = String(rawTitle).trim();

      if (!titleColumnMap.has(trimmed)) {
        titleColumnMap.set(trimmed, new Set());
      }

      titleColumnMap.get(trimmed).add(colIdx);
    });

    return Array.from(titleColumnMap.entries()).map(
      ([title, columnIndexSet]) => {
        const columnIndices = Array.from(columnIndexSet);

        return {
          key,
          title,
          columnIndexSet,
          rowId: `${key}-${title}-${columnIndices.join("_")}`,
        };
      }
    );
  });
};

export default buildAddressCompareRows;
